import { render, staticRenderFns } from "./cqShouye.vue?vue&type=template&id=fff4a214&"
import script from "./cqShouye.vue?vue&type=script&lang=js&"
export * from "./cqShouye.vue?vue&type=script&lang=js&"
import style0 from "./cqShouye.vue?vue&type=style&index=0&id=fff4a214&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports